import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const onu: AnaColumn[] = [

    {
      itemType: "group", colCount: "1", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "Codice", width: "40", hideOnEdit: true },
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione", maxSize: 255, maxLength: '255', width: 25.5 * aspect },
        { type: 'campo', dataField: "note", dataType: "", colSpan: "2", width: "350", editorType: "dxTextArea", },
        { type: 'campo', colVisible: false, dataField: "versione", hideOnEdit: true, dataType: "" },
        { type: 'campo', dataField: "nomeTabella", dataType: "", hideOnEdit: false, disableOnUpdate: true },
      ]
    },
  ]